import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../service/login/login.service';
import { AuthService } from '../../guard/auth.service';
import { MenuService } from '../../service/menu.service';


@Component({
  selector: 'app-leftnav',
  templateUrl: './leftnav.component.html',
  styleUrls: ['./leftnav.component.css']
})
export class LeftnavComponent implements OnInit {
  user_type: String = "-1";
  menuList = [];
  constructor(private loginService: LoginService, public auth: AuthService, private menuService: MenuService) {
    this.loginService.currentType.subscribe(userType =>
      this.user_type = this.auth.getType()
    )
  }

  ngOnInit() {
    this.menuList = this.menuService.getMenuList();
    this.loginService.currentType.subscribe(userType =>
      this.user_type = this.auth.getType()
    );
    let activeMenuRoute = localStorage.getItem("activeMenu") ? JSON.parse(localStorage.getItem("activeMenu")) : [];

    if(activeMenuRoute.length) {
      let menuInx: any = 0;
      let subMenuInx: any, innerMenuInx: any  = null;

      for(let inx in this.menuList) {
        if(this.menuList[inx].route == activeMenuRoute[0]) {
          menuInx = inx;
          if(this.menuList[inx].haveSubMenu) {
            for(let subInx in this.menuList[inx].subMenuList) {
              if(this.menuList[inx].subMenuList[subInx].route == activeMenuRoute[0]) {
                subMenuInx = subInx == '0' ? 0 : Number(subInx);
                menuInx = Number(inx);
                if(this.menuList[inx].subMenuList[subInx].haveSubMenu) {
                  for(let innerInx in this.menuList[inx].subMenuList[subInx].subMenuList) {
                    if(this.menuList[inx].subMenuList[subInx].subMenuList[innerInx].route == activeMenuRoute[0]) {
                      innerMenuInx = innerInx == '0' ? 0 : Number(innerInx);
                      menuInx = Number(inx);
                      subMenuInx = subInx == '0' ? 0 : Number(subInx);
                    }
                  }
                }
              } else {
                if(this.menuList[inx].subMenuList[subInx].haveSubMenu) {
                  for(let innerInx in this.menuList[inx].subMenuList[subInx].subMenuList) {
                    if(this.menuList[inx].subMenuList[subInx].subMenuList[innerInx].route == activeMenuRoute[0]) {
                      innerMenuInx = innerInx == '0' ? 0 : Number(innerInx);
                      menuInx = Number(inx);
                      subMenuInx = subInx == '0' ? 0 : Number(subInx);
                    }
                  }
                }
              }
            }
          }
        } else {
          if(this.menuList[inx].haveSubMenu) {
            for(let subInx in this.menuList[inx].subMenuList) {
              if(this.menuList[inx].subMenuList[subInx].route == activeMenuRoute[0]) {
                subMenuInx = subInx == '0' ? 0 : Number(subInx); 
                menuInx = Number(inx);
                if(this.menuList[inx].subMenuList[subInx].haveSubMenu) {
                  for(let innerInx in this.menuList[inx].subMenuList[subInx].subMenuList) {
                    if(this.menuList[inx].subMenuList[subInx].subMenuList[innerInx].route == activeMenuRoute[0]) {
                      innerMenuInx = innerInx == '0' ? 0 : Number(innerInx);
                      menuInx = Number(inx);
                      subMenuInx = subInx == '0' ? 0 : Number(subInx);
                    }
                  }
                }
              } else {
                if(this.menuList[inx].subMenuList[subInx].haveSubMenu) {
                  for(let innerInx in this.menuList[inx].subMenuList[subInx].subMenuList) {
                    if(this.menuList[inx].subMenuList[subInx].subMenuList[innerInx].route == activeMenuRoute[0]) {
                      innerMenuInx = innerInx == '0' ? 0 : Number(innerInx);
                      menuInx = Number(inx);
                      subMenuInx = subInx == '0' ? 0 : Number(subInx);
                    }
                  }
                }
              }
            }
          }
        }
      }

      if ((menuInx || menuInx == 0) && (subMenuInx != 0 && !subMenuInx) && (innerMenuInx != 0 && !innerMenuInx)) {
        if ( this.menuList[menuInx].haveSubMenu == true) { this.makeToggleEvent(this.menuList[menuInx].id) };
      } else if (((menuInx || menuInx == 0) && (subMenuInx || subMenuInx == 0) && (innerMenuInx != 0 && !innerMenuInx)) || ((menuInx || menuInx == 0) && (subMenuInx || subMenuInx == 0) && (innerMenuInx || innerMenuInx == 0))) {
        if (this.menuList[menuInx].haveSubMenu) { this.makeToggleEvent(this.menuList[menuInx].id) };
        if (this.menuList[menuInx].subMenuList[subMenuInx].haveSubMenu) { this.makeToggleEvent(this.menuList[menuInx].subMenuList[subMenuInx].id) };
      }

      this.setActiveMenu(menuInx, subMenuInx, innerMenuInx, undefined);
    }
  }

  setSubmenuNonHover = (menu) => {
    menu.subMenuList = menu.subMenuList.map((subMenu) => {
      subMenu.onhover = false;
      if (subMenu.haveSubMenu) {
        this.setSubmenuNonHover(subMenu)
      }
      return subMenu;
    });
    return menu;
  }

  setAllAsNonHover = () => {
    this.menuList = this.menuList.map((menu) => {
      menu.onhover = false;
      if (menu.haveSubMenu) {
        this.setSubmenuNonHover(menu);
      }

      return menu;
    });
  }

  addFocusColor(menuInx, subMenuInx, innerMenuInx) {
    const setNonHoverMenu = (menu) => {
      menu.onhover = false;
      return menu;
    }

    const setRemainMenuAsNonHover = () => {
      if (menuInx || menuInx == 0) {
        this.menuList = this.menuList.map((menu, inx) => {
          if (inx != menuInx) {
            menu = setNonHoverMenu(menu);
          }
          return menu;
        });
      } else if ((menuInx || menuInx == 0) && subMenuInx) {
        this.menuList = this.menuList.map((menu) => {
          menu.onhover = false;
          if (menu.haveSubMenu) {
            menu.subMenuList = menu.subMenuList.map((subMenu, subInx) => {
              if (subInx !== subMenuInx) {
                subMenu = setNonHoverMenu(subMenu);
              }

              return subMenu;
            });
          }
          return menu;
        });
      } else if ((menuInx || menuInx == 0) && subMenuInx && innerMenuInx) {
        this.menuList = this.menuList.map((menu) => {
          menu = setNonHoverMenu(menu);
          if (menu.haveSubMenu) {
            menu.subMenuList = menu.subMenuList.map((subMenu) => {
              subMenu = setNonHoverMenu(subMenu);
              if (subMenu.haveSubMenu) {
                subMenu.subMenuList = subMenu.subMenuList.map((innerMenu, innerInx) => {
                  if (innerMenuInx !== innerInx) {
                    innerMenu = setNonHoverMenu(innerMenu);
                  }
                  return innerMenu;
                });
              }
              return subMenu;
            });
          }
          return menu;
        });
      }
    }

    if ((menuInx || menuInx == 0) && (subMenuInx != 0 && !subMenuInx) && (innerMenuInx != 0 && !innerMenuInx)) {
      this.menuList[menuInx].onhover = true;
      setRemainMenuAsNonHover();
    } else if ((menuInx || menuInx == 0) && (subMenuInx || subMenuInx == 0) && (innerMenuInx != 0 && !innerMenuInx)) {
      this.menuList[menuInx].subMenuList[subMenuInx].onhover = true;
      setRemainMenuAsNonHover();
    } else if ((menuInx || menuInx == 0) && (subMenuInx || subMenuInx == 0) && (innerMenuInx || innerMenuInx == 0)) {
      this.menuList[menuInx].subMenuList[subMenuInx].subMenuList[innerMenuInx].onhover = true;
      setRemainMenuAsNonHover();
    }
  }

  disableOtherActiveMenu(menuInx, subMenuInx, innerMenuInx) {
    this.menuList = this.menuList.map((menu, index) => {
      if (menuInx != index) {
        menu.isActive = false;
        if (menu.haveSubMenu) {
          menu.subMenuList = menu.subMenuList.map((subMenu, subIndex) => {
            if (subMenuInx || subMenuInx == 0) {
              if (subMenuInx != subIndex) {
                subMenu.isActive = false;
                subMenu.isExpanded = false;
                if (subMenu.haveSubMenu) {
                  subMenu.subMenuList = subMenu.subMenuList.map((innerMenu, innerIndex) => {
                    if (innerIndex || innerMenuInx == 0) {
                      if (innerMenuInx != innerIndex) {
                        innerMenu.isActive = false;
                      }
                    } else {
                      innerMenu.isActive = false;
                    }
                    return innerMenu;
                  });
                }
              } else {
                subMenu.isActive = false;
              }
            } else {
              subMenu.isActive = false;
              if (subMenu.haveSubMenu) {
                subMenu.isExpanded = false;
                subMenu.subMenuList = subMenu.subMenuList.map((innerMenu, innerIndex) => {
                  innerMenu.isActive = false;
                  return innerMenu;
                });
              }
            }
            return subMenu;
          });
        }
      } else if (menuInx == index) {
        if (menu.haveSubMenu) {
          menu.subMenuList = menu.subMenuList.map((subMenu, subIndex) => {
            if (subMenuInx || subMenuInx == 0) {
              console.log(subMenuInx, "subIndex", subIndex);
              if ((subMenuInx != subIndex)) {
                subMenu.isActive = false;
                subMenu.isExpanded = false;
                if (subMenu.haveSubMenu) {
                  subMenu.subMenuList = subMenu.subMenuList.map((innerMenu, innerIndex) => {
                    if (innerMenuInx || innerMenuInx == 0 || innerMenuInx != null) {
                      if (innerMenuInx != innerIndex) {
                        innerMenu.isActive = false;
                      }
                    } else {
                      innerMenu.isActive = false;
                    }
                    return innerMenu;
                  });
                }
              } else {
                if (subMenu.haveSubMenu) {
                  subMenu.subMenuList = subMenu.subMenuList.map((innerMenu, innerIndex) => {
                    if (innerMenuInx || innerMenuInx == 0 || innerMenuInx != null) {
                      if (innerMenuInx != innerIndex) {
                        innerMenu.isActive = false;
                      }
                    } 
                    return innerMenu;
                  });
                }
              }
            } else {
              // subMenu.isActive = false;
              // if (subMenu.haveSubMenu) {
              //   subMenu.isExpanded = false;
              //   subMenu.subMenuList = subMenu.subMenuList.map((innerMenu, innerIndex) => {
              //     innerMenu.isActive = false;
              //     return innerMenu;
              //   });
              // }
            }
            return subMenu;
          });
        }
      }
      return menu;
    });

  }

  setActiveMenu(menuInx, subMenuInx, innerMenuInx, event) {
    if(!event || !event.target.value) {
      if ((menuInx || menuInx == 0) && (subMenuInx != 0 && !subMenuInx) && (innerMenuInx != 0 && !innerMenuInx)) {
        this.menuList[menuInx].isActive = true;
        if (this.menuList[menuInx].haveSubMenu == true) { this.menuList[menuInx].isExpanded = true };
        localStorage.setItem("activeMenu", JSON.stringify(this.menuList[menuInx].route));
        this.removeCollapseClass(this.menuList[menuInx].id);
      } else if ((menuInx || menuInx == 0) && (subMenuInx || subMenuInx == 0) && (innerMenuInx != 0 && !innerMenuInx)) {
        this.menuList[menuInx].isActive = true;
        if (this.menuList[menuInx].haveSubMenu == true) { this.menuList[menuInx].isExpanded = true };
        this.menuList[menuInx].subMenuList[subMenuInx].isActive = true;
        if (this.menuList[menuInx].subMenuList[subMenuInx].haveSubMenu == true) { this.menuList[menuInx].subMenuList[subMenuInx].isExpanded = true };
        localStorage.setItem("activeMenu", JSON.stringify(this.menuList[menuInx].subMenuList[subMenuInx].route));
        this.removeCollapseClass(this.menuList[menuInx].subMenuList[subMenuInx].id);
      } else if ((menuInx || menuInx == 0) && (subMenuInx || subMenuInx == 0) && (innerMenuInx || innerMenuInx == 0)) {
        this.menuList[menuInx].isActive = true;
        if (this.menuList[menuInx].haveSubMenu == true) { this.menuList[menuInx].isExpanded = true };
        this.menuList[menuInx].subMenuList[subMenuInx].isActive = true;
        if (this.menuList[menuInx].subMenuList[subMenuInx].haveSubMenu == true) { this.menuList[menuInx].subMenuList[subMenuInx].isExpanded = true };
        this.menuList[menuInx].subMenuList[subMenuInx].subMenuList[innerMenuInx].isActive = true;
        localStorage.setItem("activeMenu", JSON.stringify(this.menuList[menuInx].subMenuList[subMenuInx].subMenuList[innerMenuInx].route));
      }
  
      this.disableOtherActiveMenu(menuInx, subMenuInx, innerMenuInx);
    }

    if(event) {
      event.preventDefault();
    }
    
  }

  removeCollapseClass(id) {
    setTimeout(() => {
      const element = document.getElementById(id);
      if (!element.classList.contains('show')) {
        element.classList.remove('collapse'); // Show the element
      }
    }, 400);
  }

  makeToggleEvent(id) {    
    setTimeout(() => {
      const element = document.getElementById(id);
      (element as HTMLInputElement).value = "TS";
      element.click();
      setTimeout(() => {
        (element as HTMLInputElement).value = '';  // Clear the value after the click
      }, 100);
    }, 100);
  }
}
